import React, { useEffect } from 'react';

import { get, values } from 'lodash';
import Element from '../../../../components/element';
import Flex from '../../../../components/flex';
import Text from '../../../../components/text';
import NoData from '../../NoData';
import { create, updateData } from '../../Chart/DistributionChart/chart';
import circle from '../../../../assets/icons/circlequestionmark.svg';
// import Human1 from '../../../../assets/icons/human1.png';
// import Human2 from '../../../../assets/icons/human2.png';
// import Human3 from '../../../../assets/icons/human3.png';
// import Human4 from '../../../../assets/icons/human4.png';

const Antropometrics = ({ healthReportData }) => {
  const toFeet = (n, view) => {
    var realFeet = (n * 0.3937) / 12;
    var feet = Math.floor(realFeet);
    var inches = Math.round((realFeet - feet) * 12);
    if (inches >= 12) {
      feet = feet + (inches / 12);
      inches = 0;
    }
    if (view === 'no') {
      return `${feet}.${inches}`;
    } else {
      return `${feet}'${inches}''`;
    }
  };
  function returnObject(n, key, view) {
    if (key === 'height') {
      return toFeet(n, view);
    } else {
      return n;
    }
  }
  useEffect(() => {
    const anthropometricsList = values(healthReportData.anthropometrics).slice(
      0,
      7
    );
    let newArray = [];

    anthropometricsList.filter(each => {
      let keyId =
        each.display_label &&
        each.display_label.replace(/ /g, '_').toLowerCase();
      if (
        keyId === 'height' ||
        keyId === 'weight' ||
        keyId === 'waist_to_hip_ratio' ||
        keyId === 'trunk_to_leg_volume_ratio' ||
        keyId === 'waist_circumference'

      ) {
        let data = {
          ...each,
          section: 'anthropometrics',
          chartVal: each.value ? returnObject(each.value, keyId, 'no') : 0,
          key: keyId
        };
        newArray.push(data);
      }
    });

    newArray.map(each => {
      var settings = {
        el: each.display_label.replace(/ /g, '_') || 'none',
        margin: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      };
      create(settings);
      updateData(each);
    });
    // risk caliculator for value more than 0
    if (healthReportData.riskScore && healthReportData.riskScore.length > 0) {
      if (healthReportData.riskScore[0].value > 0) {
        const data1 = { ...healthReportData.riskScore[0], section: 'riskscore', chartVal: healthReportData.riskScore[0].value };
        const settings1 = {
          el: healthReportData.riskScore[0].display_label.replace(/ /g, '_'),
          margin: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
        create(settings1);
        updateData(data1);
      }
    }

    // --end

  }, []);

  return (
    <Element>
      {get(healthReportData, 'anthropometrics.height.value') === null &&
        get(healthReportData, 'anthropometrics.weight.value') === null &&
        get(healthReportData, 'anthropometrics.waist_to_hip_ratio.value') ===
        null &&
        get(
          healthReportData,
          'anthropometrics.trunk_to_leg_volume_ratio.value'
        ) === null &&
        get(healthReportData, 'anthropometrics.waist_circumference.value') ===
        null ? (
        <NoData />
      ) : (
        <Element>
          <Element marginBottom="20px" marginTop="30px">
            <Text family="GTAM" size="14px" color="#222222">
              Anthropometrics is the measurement of a person's body geometry
              (lengths, circumferences, areas, and volumes). Thorne Lab uses 3D
              body surface scanning to measure clinically relevant
              anthropometrics.
            </Text>
          </Element>
          <Flex align="center">
            <Element width="140px" marginRight="30px">
              <Text family="GTAM" size="16px" color="#222222">
                Height
              </Text>
            </Element>
            <Element marginRight="50px" width="75px">
              <Text
                family="GTAM"
                size="24px"
                color="#222222"
                marginBottom="0px"
              >
                {toFeet(
                  get(healthReportData, 'anthropometrics.height.value'),
                  'yes'
                )}
              </Text>
              <Text family="GTAR" size="14px" color="#959595" marginTop="0px">
                Feet
              </Text>
            </Element>
            <Element marginRight="50px" width="75px">
              <Text
                family="GTAM"
                size="24px"
                color="#222222"
                marginBottom="0px"
              >
                {/* {Number(
                  get(healthReportData, 'anthropometrics.height.percentile')
                ).toFixed(2)}
                % */}
                {Math.floor(
                  Number(
                    get(healthReportData, 'anthropometrics.height.percentile')
                  ) * 10
                ) /
                  10 +
                  '%' || 0 + '%'}
              </Text>
              <Element marginTop="1px">
                <Text family="GTAR" size="14px" color="#959595" marginTop="0px">
                  Percentile
                </Text>
              </Element>
            </Element>
            <div
              id={get(
                healthReportData,
                'anthropometrics.height.display_label'
              ).replace(/ /g, '_')}
              style={{ width: '30%' }}
            ></div>
          </Flex>
          <Flex align="center" marginTop="50px">
            <Element width="140px" marginRight="30px">
              <Text family="GTAM" size="16px" color="#222222">
                Weight
              </Text>
            </Element>
            <Element marginRight="50px" width="75px">
              <Text
                family="GTAM"
                size="24px"
                color="#222222"
                marginBottom="0px"
              >
                {get(healthReportData, 'anthropometrics.weight.value')}
              </Text>
              <Text family="GTAR" size="14px" color="#959595" marginTop="0px">
                Lbs
              </Text>
            </Element>
            <Element marginRight="50px" width="75px">
              <Text
                family="GTAM"
                size="24px"
                color="#222222"
                marginBottom="0px"
              >
                {Math.floor(
                  Number(
                    get(healthReportData, 'anthropometrics.weight.percentile')
                  ) * 10
                ) /
                  10 +
                  '%' || 0 + '%'}
                {/* {Number(
                  get(healthReportData, 'anthropometrics.weight.percentile')
                ).toFixed(2)}
                % */}
              </Text>
              <Element marginTop="1px">
                <Text family="GTAR" size="14px" color="#959595" marginTop="0px">
                  Percentile
                </Text>
              </Element>
            </Element>
            <div
              id={get(
                healthReportData,
                'anthropometrics.weight.display_label'
              ).replace(/ /g, '_')}
              style={{ width: '30%' }}
            ></div>
          </Flex>
          <Flex align="center" marginTop="50px">
            <Element width="140px" marginRight="30px">
              <Text family="GTAM" size="16px" color="#222222">
                Waist Circumference
              </Text>
            </Element>
            <Element marginRight="50px" width="75px">
              <Text
                family="GTAM"
                size="24px"
                color="#222222"
                marginBottom="0px"
              >
                {get(
                  healthReportData,
                  'anthropometrics.waist_circumference.value'
                )}
              </Text>
              <Text family="GTAR" size="14px" color="#959595" marginTop="0px">
                Inches
              </Text>
            </Element>
            <Element marginRight="50px" width="75px">
              <Text
                family="GTAM"
                size="24px"
                color="#222222"
                marginBottom="0px"
              >
                {Math.floor(
                  Number(
                    get(
                      healthReportData,
                      'anthropometrics.waist_circumference.percentile'
                    )
                  ) * 10
                ) /
                  10 +
                  '%' || 0 + '%'}
                {/* {Number(
                  get(
                    healthReportData,
                    'anthropometrics.waist_circumference.percentile'
                  )
                ).toFixed(2)} */}
              </Text>
              <Element marginTop="1px">
                <Text family="GTAR" size="14px" color="#959595" marginTop="0px">
                  Percentile
                </Text>
              </Element>
            </Element>
            <div
              id={get(
                healthReportData,
                'anthropometrics.waist_circumference.display_label'
              ).replace(/ /g, '_')}
              style={{ width: '30%' }}
            ></div>
          </Flex>
          <Flex align="center" marginTop="50px">
            <Element width="140px" marginRight="30px">
              <Text family="GTAM" size="16px" color="#222222">
                Waist to Hip Ratio
              </Text>
            </Element>
            <Element marginRight="50px" width="75px">
              <Text
                family="GTAM"
                size="24px"
                color="#222222"
                marginBottom="0px"
              >
                {get(
                  healthReportData,
                  'anthropometrics.waist_to_hip_ratio.value'
                )}
              </Text>
              <Text family="GTAR" size="14px" color="#959595" marginTop="0px">
                Ratio
              </Text>
            </Element>
            <Element marginRight="50px" width="75px">
              <Text
                family="GTAM"
                size="24px"
                color="#222222"
                marginBottom="0px"
              >
                {Math.floor(
                  Number(
                    get(
                      healthReportData,
                      'anthropometrics.waist_to_hip_ratio.percentile'
                    )
                  ) * 10
                ) /
                  10 +
                  '%' || 0 + '%'}
                {/* {Number(
                  get(
                    healthReportData,
                    'anthropometrics.waist_to_hip_ratio.percentile'
                  )
                ).toFixed(2)}
                % */}
              </Text>
              <Element marginTop="1px">
                <Text family="GTAR" size="14px" color="#959595" marginTop="0px">
                  Percentile
                </Text>
              </Element>
            </Element>
            <div
              id={get(
                healthReportData,
                'anthropometrics.waist_to_hip_ratio.display_label'
              ).replace(/ /g, '_')}
              style={{ width: '30%' }}
            ></div>
          </Flex>
          <Flex align="center" marginTop="50px">
            <Element width="140px" marginRight="30px">
              <Text family="GTAM" size="16px" color="#222222">
                Trunk to Leg Volume Ratio
              </Text>
            </Element>
            <Element marginRight="50px" width="75px">
              <Text
                family="GTAM"
                size="24px"
                color="#222222"
                marginBottom="0px"
              >
                {get(
                  healthReportData,
                  'anthropometrics.trunk_to_leg_volume_ratio.value'
                )}
              </Text>
              <Text family="GTAR" size="14px" color="#959595" marginTop="0px">
                Ratio
              </Text>
            </Element>
            <Element marginRight="50px" width="75px">
              <Text
                family="GTAM"
                size="24px"
                color="#222222"
                marginBottom="0px"
              >
                {Math.floor(
                  Number(
                    get(
                      healthReportData,
                      'anthropometrics.trunk_to_leg_volume_ratio.percentile'
                    )
                  ) * 10
                ) /
                  10 +
                  '%' || 0 + '%'}
                {/* {Number(
                  get(
                    healthReportData,
                    'anthropometrics.trunk_to_leg_volume_ratio.percentile'
                  )
                ).toFixed(2)}
                % */}
              </Text>
              <Element marginTop="1px">
                <Text family="GTAR" size="14px" color="#959595" marginTop="0px">
                  Percentile
                </Text>
              </Element>
            </Element>
            <div
              id={get(
                healthReportData,
                'anthropometrics.trunk_to_leg_volume_ratio.display_label'
              ).replace(/ /g, '_')}
              style={{ width: '30%' }}
            ></div>
          </Flex>

          {healthReportData.riskScore && healthReportData.riskScore.length > 0 && healthReportData.riskScore[0].value > 0 ? (

            <Flex align="center" marginTop="50px">
              <Element width="140px" marginRight="30px">

                <Text family="GTAM" size="16px" color="#222222">
                  <img style={{ "marginLeft": "-32px" }} src={circle} width="30px" height="30px" /> ASCVD Risk
                </Text>
              </Element>
              <Element marginRight="50px" width="75px">
                <Text
                  family="GTAM"
                  size="24px"
                  color="#222222"
                  marginBottom="0px"
                >
                  {((Math.round(healthReportData.riskScore[0].value * 100) / 100).toFixed(2)).replace('.00', '')}%
                </Text>
                <Text family="GTAR" width="77px" size="14px" color="#959595" marginTop="0px">
                  10 Year Risk
                </Text>
              </Element>
              <Element marginRight="50px" width="75px">
                <Text
                  family="GTAM"
                  size="24px"
                  color="#222222"
                  marginBottom="0px"
                >
                  {((Math.round(healthReportData.riskScore[1].value * 100) / 100).toFixed(2)).replace('.00', '')}%

                </Text>
                <Element marginTop="1px">
                  <Text family="GTAR" width="83px" size="14px" color="#959595" marginTop="0px">
                    Lifetime Risk
                  </Text>
                </Element>
              </Element>
              <div
                id="ASCVD_Risk"
                style={{ width: '30%' }}
              ></div>
            </Flex>

          ) : ''}


          <Flex align="center" marginTop="50px" width="170px">
            <img
              id="img_000"
              src={get(healthReportData, 'anthropometrics.images.000_deg')}
            />
            <img
              id="img_001"
              src={get(healthReportData, 'anthropometrics.images.120_deg')}
            />
            <img
              id="img_002"
              src={get(healthReportData, 'anthropometrics.images.270_deg')}
            />
            <img
              id="img_003"
              src={get(healthReportData, 'anthropometrics.images.315_deg')}
            />
          </Flex>

        </Element>
      )}
    </Element>
  );
};

export default Antropometrics;
